import styled from 'styled-components';
import { useEffect, useState } from 'react';
import SearchBar from '../components/studyroom/SearchBar';
import InitialFilter from '../components/studyroom/InitialFilter';
import StudyroomService from '../../service/studyroom/Studyroom';

export interface Term {
  term: string;
  definition: string;
}

function AuctionTerm() {
  const [initial, setInitial] = useState('전체');
  const [search, setSearch] = useState('');
  const [termList, setTermList] = useState<Term[]>([]);
  const [input, setInput] = useState('');

  const getList = async () => {
    try {
      const consonant = initial === '전체' ? '' : initial;

      const res = await StudyroomService.terms(consonant, search);
      setTermList(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getList();
  }, [initial]);

  useEffect(() => {
    if (initial === '전체') {
      getList();
    }
    setInitial('전체');
  }, [search]);

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  return (
    <Container>
      <SearchBox>
        <InitialFilter initial={initial} setInitial={setInitial} />
        <SearchBar onSearch={handleSearch} input={input} setInput={setInput} />
      </SearchBox>
      <TermBox>
        {termList.map((term) => (
          <TermContainer key={term.term}>
            <Title>{term.term}</Title>
            <Description>{term.definition}</Description>
          </TermContainer>
        ))}
        {termList.length === 0 && (
          <NoList>
            <NoListDescription>
              검색결과가 없습니다.
              <br /> 철자를 다시 확인하거나 다른 키워드로 검색해보세요.
            </NoListDescription>
            <Button
              onClick={() => {
                setSearch('');
                setInput('');
              }}
            >
              전체 용어 보기
            </Button>
          </NoList>
        )}
      </TermBox>
    </Container>
  );
}

export default AuctionTerm;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const SearchBox = styled.div`
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: row;
  padding: 16px;
  gap: 16px;
`;

const TermBox = styled.div`
  padding: 16px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
`;

const TermContainer = styled.div`
  width: 100%;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #e1e2e4;

  &:last-child {
    border-bottom: none;
  }
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

const Description = styled.div`
  font-weight: 500;
  font-size: 14px;
  white-space: pre-wrap;
  color: #616161;
`;

const NoList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  gap: 16px;
  align-items: center;
`;

const NoListDescription = styled(Description)`
  text-align: center;
  padding: 16px;
`;

const Button = styled.button`
  background-color: #70737c14;
  border-radius: 8px;
  padding: 14px 28px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
  cursor: pointer;
  border: none;
`;
